import { render, staticRenderFns } from "./PostalAreas.vue?vue&type=template&id=5084f2a1"
import script from "./PostalAreas.vue?vue&type=script&lang=js"
export * from "./PostalAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports